














































































































import { Component, Prop, Watch } from "vue-property-decorator";
import { ITag } from "@/models/tag.entity";
import TagChip from "@/components/tag/TagChip.vue";
import CreateTagDialog from "./CreateTagDialog.vue";
import { mixins } from "vue-class-component";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { RefsTagModule } from "@/store/modules/refs.store";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { handleError } from "@/lib/utility/handleError";
import { debounce } from "debounce";
import { TagGoToHelper } from "@/lib/utility/tag.go-to-helper";

@Component({
  components: {
    TagChip,
    CreateTagDialog
  }
})
export default class SelectTags extends mixins(RulesMixin) {
  readonly TagGoToHelper = TagGoToHelper;

  @Prop({ default: () => [] })
  value!: ITag[];

  @Prop({ required: true })
  resource!: BackendResourceEnum;

  @Prop({ required: true })
  partnerId!: string;

  @Prop({ default: false })
  disabled!: boolean;

  @Prop({ default: false })
  readonly!: boolean;

  @Prop()
  loading?: boolean;

  @Prop({ default: "", required: false })
  prependIcon?: string;

  @Prop({ default: true })
  outlined!: boolean;

  @Watch("isMenu")
  onMenuChange(newValue: boolean) {
    if (!newValue) {
      this.updateTags();
    }
  }

  isMenu = false;

  selected: string[] = [];

  isCreateDialogActive = false;

  isLoadingTags = false;

  search = "";

  menuWidth = 400;

  get availableTags(): ITag[] {
    return RefsTagModule.filteredAndSorted;
  }

  get selectedTags(): ITag[] {
    return this.value.filter(tag => this.availableTags.find(v => v.id === tag.id));
  }

  get availableUnselectedTags(): ITag[] {
    return this.availableTags.filter(tag => !this.value.find(v => v.id === tag.id));
  }

  get tagFilter(): IPageFilterElement {
    return new PageFilterElement({
      key: "resources",
      operation: PageFilterOperationEnum.EQUAL,
      value: this.resource
    });
  }

  updateTags() {
    this.resetFilter();
    const tags = this.selected
      .map(tagId => {
        return this.availableTags.find(t => t.id === tagId);
      })
      .filter(t => t !== undefined) as ITag[];

    const selectedTags = tags;
    this.$emit("input", selectedTags);
    this.$emit("change", selectedTags);
  }

  openCreateDialog() {
    this.isCreateDialogActive = true;
  }

  onTagCreated(tag: ITag) {
    if (tag.resources.length === 0 || tag.resources.includes(this.resource)) {
      this.selected.push(tag.id);
      this.updateTags();
    }
  }

  openMenu() {
    this.resetFilter();
    this.isMenu = true;
    this.selected.splice(0);
    this.selected.push(...this.value.map(tag => tag.id));

    this.$nextTick(() => {
      const activator = this.$refs.activator as HTMLElement;
      if (activator) {
        this.menuWidth = activator.offsetWidth;
      }
    });

    this.fetchTags();
  }

  beforeDestroy() {
    RefsTagModule.setFilters([]);
    RefsTagModule.setSearch("");
  }

  @Watch("search")
  debouncedSearch = debounce(this.fetchTags, 500);

  mounted() {
    RefsTagModule.setFilters([this.tagFilter]);
  }

  resetFilter() {
    this.search = "";
    RefsTagModule.setFilters([this.tagFilter]);
    RefsTagModule.setSearch("");
  }

  toggleSelected(tagId: string) {
    const index = this.selected.indexOf(tagId);
    if (index > -1) {
      this.selected.splice(index, 1);
    } else {
      this.selected.push(tagId);
    }
  }

  async fetchTags() {
    this.isLoadingTags = true;
    RefsTagModule.setFilters([this.tagFilter]);
    RefsTagModule.setSearch(this.search || "");
    await RefsTagModule.fetchFirstPage({ partnerId: this.partnerId }).catch(handleError);

    this.isLoadingTags = false;
  }

  clearTags() {
    this.selected.splice(0);
    this.updateTags();
  }
}
